var finansudd = finansudd || {};

finansudd.slider = new function () {

    var self = this,
    	prevHtml = '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/dist/icons/icons.svg#arrow-left"></use></svg>',
		nextHtml = '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/dist/icons/icons.svg#arrow-right"></use></svg>';


    this.testimonialSlider = function (selector) {

        $(selector).owlCarousel({
            loop: false,
            margin: 10,
            nav: true,
            navText: [prevHtml, nextHtml],
            items: 1
        })

    };

    this.videoSlider = function (selector) {
        if (selector.length) {
            selector.owlCarousel({
                autoplay: false,
                margin: 10,
                video: true,
                singleItem: true,
                lazyLoad: true,
                rewindNav: true,
                nav: true,
                loop: false,
                navText: [prevHtml, nextHtml],
                dots: true,
                onInitialized: function (event) {
                    lazyloadOnVideos();
                },
                onChanged: function (event) {
                    stopVideos();

                },
                responsive: {
                    0: {
                        items: 1,
                        dots: false
                    },

                    768: {
                        items: 1,
                    },

                    992: {
                        items: 1
                    }
                }
            });
        }

        function stopVideos(event) {
            // Stop all other video items on initialize
            $('.video-container iframe').remove();
            $('.video-container .fluid-width-video-wrapper').hide();
            $('.video-container figure').show();
        }

        function lazyloadOnVideos() {
            // Lazyload on video ex. in tab modul
            $('.play-video').click(function (e) {
                e.preventDefault();
                var videoContainer = $(this).closest('.video-container');
                var videoId = videoContainer.attr('data-video');
                videoContainer.append('<iframe src="' + videoId + '?autoplay=true&rel=0" frameborder="0" allowfullscreen></iframe>').fitVids();
                $('.video-container figure').hide();

            });

        }
    };

    this.newsSlider = function (selector) {

        $(selector).owlCarousel({
            loop: false,
            margin: 10,
            nav: false,
            navText: [prevHtml, nextHtml],
            items: 3,
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 3
                }
            }
        })

    };


};